import React from "react";
import ProjectCard from "./ProjectCard";

const Projects = () => {
  const projectData = [
    // {
    //   title: "Pointus",
    //   subtitle: "C#, XAML",
    //   description:
    //     "(In Progress) Collaborate with UF Music faculty to design and create an application to improve the efficiency of grading counterpoint exercises, as well as aid in students ability to write effective counterpoint.",
    //   date: "August 2025 - Present",
    // },
    {
      title: "Grouper",
      subtitle: "MongoDB, React, Google OAuth 2.0, FastAPI",
      description:
        "Led development on a multiuser web application which connects user accounts using Google's OAuth 2.0 workflow to optimally schedule events across multiple groups of people.",
      date: "June 2023 – August 2023",
      link: "https://github.com/NicholasGaudio/Grouper",
      image: "../grouper.png",
    },
    {
      title: "Virtual Turlington",
      subtitle: "MongoDB, Express, React, Node, Python",
      description:
        "Collaborated in a 4-person team to create a centralized online hub for UF clubs for advertisement and communication.",
      date: "March 2024",
      link: "https://github.com/CaseZumbrum/virtual_Turlington",
      image: "/turl.png",
    },
    {
      title: "Board Buddy",
      subtitle: "C++, Kaggle",
      description:
        "Developed an analysis tool to quickly and efficiently query across thousands of chess games, allowing for faster improvement in chess skills.",
      date: "February 2024 - March 2024",
      link: "https://github.com/declanmckoen/BoardBuddy",
      image: "/buddy.png",
    },
    {
      title: "Minesweeper",
      subtitle: "C++ SFML Library",
      description:
        "Recreated class Minesweeper in game applying OOP principles utilizing the C++ SFML Library.",
      date: "November 2023 - December 2023",
      link: "https://github.com/CaseZumbrum/gatorHacks",
      image: "/minesweeper.jpg",
    },
    {
      title: "Chat with Verizy",
      subtitle: "React, Node, Express, OpenAI Turbo 3.5",
      description:
        "Developed an AI-based Verizon agent that is able to quickly provide information about Verizon products and provide quick-chat options for streamlined navigation..",
      date: "October 2023",
      link: "https://github.com/CaseZumbrum/gatorHacks",
      secondaryLink: "https://youtu.be/dXxXQMYBYGQ",
      secondaryText: "View Demo",
      image: "/verizy.jpg",
    },
    {
      title: "You're Not ALoan",
      subtitle: "React, Python (Typai), Node.js",
      description:
        "Developed a web application that locates and displays information about loan sharks nearby, warning users of the dangers of taking out payday loans.",
      date: "September 2023",
      link: "https://github.com/CaseZumbrum/ShelHacks_You_Are_Not_ALoan",
      image: "/notaloan.jpg",
    },
    {
      title: "Auction House Manager",
      subtitle: "MongoDB, Express, Node.js. React",
      description:
        "Developed a web application that allows users to create timed auctions for virtual items and to view the current bidding statistics for the item.",
      date: "June 2023 – August 2023",
      link: "https://github.com/justinwang05/auction-house",
    },
    {
      title: "Disco Snake",
      subtitle: "Java",
      description:
        "Developed a Java application that is a colorful twist on the classic game of Snake.",
      date: "June 2023 – August 2023",
      link: "https://github.com/justinwang05/DiscoSnake",
    },
  ];

  return (
    <div id="projects" className="py-16 bg-theme-default">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-8">My Projects</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          {projectData.map((project, index) => (
            <ProjectCard
              key={index}
              title={project.title}
              subtitle={project.subtitle}
              description={project.description}
              date={project.date}
              link={project.link}
              secondaryLink={project.secondaryLink}
              secondaryText={project.secondaryText}
              image={project.image}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
